import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  // >>> PLENARIUM:ACESSO_HORARIOS -- admin, operador e TV: o login se renova sozinho enquanto o sistema
  // estiver aberto (a cada 30 min e ao voltar para a tela). Antes vencia em 8 horas,
  // ate no meio da sessao. Login ja vencido nao renova: precisa entrar de novo.
  useEffect(() => {
    let parado = false;
    const renovar = async () => {
      const t = localStorage.getItem('token');
      if (!t || parado) return;
      let dados = null;
      try { const p = t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'); dados = JSON.parse(atob(p + '==='.slice((p.length + 3) % 4))); } catch (e) { return; }
      if (!dados || dados.role === 'vereador' || !dados.exp || dados.exp * 1000 <= Date.now()) return;
      try {
        const r = await axios.post('/api/auth/renovar', {}, { headers: { Authorization: `Bearer ${t}` } });
        const novo = r && r.data && r.data.token;
        if (novo && localStorage.getItem('token') === t) {
          localStorage.setItem('token', novo);
          if (axios.defaults.headers.common['Authorization']) axios.defaults.headers.common['Authorization'] = `Bearer ${novo}`;
        }
      } catch (e) { /* sem internet: tenta de novo na proxima vez */ }
    };
    const primeira = setTimeout(renovar, 5000);
    const intervalo = setInterval(renovar, 30 * 60 * 1000);
    const aoVoltar = () => { if (document.visibilityState === 'visible') renovar(); };
    document.addEventListener('visibilitychange', aoVoltar);
    return () => { parado = true; clearTimeout(primeira); clearInterval(intervalo); document.removeEventListener('visibilitychange', aoVoltar); };
  }, []);
  // <<< PLENARIUM:ACESSO_HORARIOS

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname.startsWith('/camara/')) {
      setLoading(false);
      return;
    }

    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const userData = JSON.parse(localStorage.getItem('usuario') || 'null');
      setUsuario(userData);
    }
    setLoading(false);
  }, [token]);

  const loginAdmin = async (email, senha) => {
    const res = await axios.post('/api/auth/admin/login', { email, senha });
    const { token: t, usuario: u } = res.data;
    localStorage.setItem('token', t);
    localStorage.setItem('usuario', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${t}`;
    setToken(t);
    setUsuario(u);
    return u;
  };

  const loginVereador = async (cpf, senha) => {
    const res = await axios.post('/api/auth/vereador/login', { cpf, senha });
    const { token: t, usuario: u } = res.data;
    localStorage.setItem('token', t);
    localStorage.setItem('usuario', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${t}`;
    setToken(t);
    setUsuario(u);
    return u;
  };

  const loginOperador = async (cpf, senha) => {
    const res = await axios.post('/api/auth/operador/login', { cpf, senha });
    const { token: t, usuario: u } = res.data;
    localStorage.setItem('token', t);
    localStorage.setItem('usuario', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${t}`;
    setToken(t);
    setUsuario(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, token, loading, loginAdmin, loginVereador, loginOperador, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);